import { gql } from '@apollo/client';
import { LibraryCategoryFoodBeverageFragment } from './libraryCategoryFoodBeverage';
import { LibraryCuisineTypeFragment } from './libraryCuisineType';
import { LibraryPriceLevelFragment } from './libraryPriceLevel';
import { LibrarySocialMediaLinksFragment } from './librarySocialMediaLinks';

export interface ILibraryBrandFoodBeverage {
  id: string;
  name: string;
  slug: string;
  description: any;
  logo: any;
  coverImage: any;
  primaryCategory: any;
  secondaryCategories: any;
  cuisine: any;
  priceLevel: any;
  socialMediaLinks: any;
  seoDescription: any;
}

export const LibraryBrandFoodBeverageFragment = gql`
  ${LibraryCategoryFoodBeverageFragment}
  ${LibraryCuisineTypeFragment}
  ${LibraryPriceLevelFragment}
  ${LibrarySocialMediaLinksFragment}
  fragment LibraryBrandFoodBeverage on LibraryBrandFoodBeverage {
    sys {
      id
    }
    name
    slug
    description {
      json
    }
    logo {
      url
      description
      height
      width
    }
    coverImage {
      url
      description
      height
      width
    }
    primaryCategory {
      ...LibraryCategoryFoodBeverage
    }
    secondaryCategoriesCollection(limit: 10) {
      items {
        ...LibraryCategoryFoodBeverage
      }
    }
    cuisineCollection(limit: 5) {
      items {
        ...LibraryCuisineType
      }
    }
    priceLevel {
      ...LibraryPriceLevel
    }
    socialMediaLinks {
      ...LibrarySocialMediaLinks
    }
    seoDescription
  }
`;

export const LibraryBrandFoodBeverageMinifiedFragment = gql`
  ${LibraryCategoryFoodBeverageFragment}
  fragment LibraryBrandFoodBeverageMinified on LibraryBrandFoodBeverage {
    sys {
      id
      locale
    }
    name
    slug
    logo {
      description
      url
      height
      width
    }
    coverImage {
      description
      url
      height
      width
    }
    primaryCategory {
      ...LibraryCategoryFoodBeverage
    }
    secondaryCategoriesCollection(limit: 10) {
      items {
        ...LibraryCategoryFoodBeverage
      }
    }
  }
`;
